import React from 'react';
import FormSteps from '../FormSteps';
import FormField from '../../../../FormField';
import mailIcon from '../../../../../assets/svg/mail.svg';

/**
 * @param {Object} formik
 * @param {Function} goToNextStep
 * @param {Function} skipStep
 */

const BrandEmailStep = ({ formik, goToNextStep, skipStep }) => {
    const handleNext = () => {
        goToNextStep('businessEmail');
    };

    const handleSkip = () => {
        formik.setFieldValue('businessEmail', '');
        skipStep();
    };

    return (
        <FormSteps
            header="What is your Business email?"
            description="Enter the official email of your brand or company."
            nextButton={handleNext}
            skipButton={handleSkip}
        >
            <div className="field mb-6">
                <div className="field-body email-field-body">
                    <div className="icon-input email-icon-input">
                        <img
                            src={mailIcon}
                            alt="Email"
                            className="input-icon"
                        />
                        <FormField
                            additionalInputClasses="has-background-white"
                            name="businessEmail"
                            type="email"
                            placeholder="Enter email"
                            onChange={formik.handleChange}
                            value={formik.values.businessEmail}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </div>
                {formik.touched.businessEmail && formik.errors.businessEmail && (
                    <p className="help is-danger">{formik.errors.businessEmail}</p>
                )}
            </div>
        </FormSteps>
    );
};

export default BrandEmailStep;